module.exports = __webpack_public_path__ + "static/media/bg-banner-primary.d4bb623c.jpg";